export default function shouldFireOnFocus(isFocused, queryClient, refetch, setBankForTransfer) {
  if (isFocused) {
    queryClient.invalidateQueries({ queryKey: ['me_api'] }).then(() => {
      refetch();
    });
    setBankForTransfer(null);
  }
}
